/**
 * Import
 * - Libraries
 */
import { connect } from 'react-redux'
import { get } from 'lodash'

/**
 * Import
 * - Store
 */
import { RootState } from '../../../../store'

/**
 * Import
 * - Actions
 */
import { getPolicyMTA, addMTA } from '../../../../actions'
import {
    fetchCountries,
} from '../../../../actions'

/**
 * Import
 * - Page component
 */
import MTA from '../../../../components/pages/Policies/MTA/MTA'

const mapStateToProps = (state: RootState, props: any) => {
    return {
        policy: state.mta.policy,
        policySubmit: state.mta.submit,
        countries: state.step00.countries,
        isCollectors: get(state, 'mta.policy.response.isCollectors', ''),
        isMuseums: get(state, 'mta.policy.response.isMuseums', ''),
        isDealersStock: get(state, 'mta.policy.response.isDealersStock', ''),
        isWineSpirits: get(state, 'mta.policy.response.isWineSpirits', ''),
        isWineSpiritsSteve: get(state, 'mta.policy.response.isWineSpiritsSteve', false),
        mta_add: state.mta.cal_mta,
    }
}

export default connect(
    mapStateToProps,
    {
        getPolicyMTA,
        addMTA,
        fetchCountries,
    }
)(MTA)



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/containers/pages/Policies/MTA/MTA.tsx